import { parameterize } from '@moda/portal-stanchions';
import { canGenerateFastPath, generateFastPath, mapPathParams } from './generateFastPath';
import { CATEGORY_SLUGS } from './categories';

export type Params = { [param: string]: string | undefined };
export type GenerateHref = (params?: Params, shouldParameterize?: boolean) => string;

const VALID_CATEGORY_SLUGS = new Set(Object.values(CATEGORY_SLUGS));

const isValidCategory = (category: string | undefined, shouldParameterize = true): boolean => {
  if (!category) return true;
  const slug = shouldParameterize ? parameterize(category) : category;
  return VALID_CATEGORY_SLUGS.has(slug);
};

const generateHrefFromSinglePattern = (
  pattern: string,
  params: Params = {},
  shouldParameterize = true
) => generateFastPath(pattern, mapPathParams(params, shouldParameterize));

const canGenerateHrefFromSinglePattern = (
  pattern: string,
  params: Params = {},
  shouldParameterize = true
) => canGenerateFastPath(pattern, mapPathParams(params, shouldParameterize));

export const safeGenerateHref = (
  pattern: string | string[],
  params: Params = {},
  shouldParameterize = true
) => {
  if (params?.category && !isValidCategory(params?.category, shouldParameterize)) {
    params = { ...params, category: undefined };
  }
  return generateHref(pattern)(params, shouldParameterize);
};

export const generateHref =
  (pattern: string | string[]): GenerateHref =>
  (params = {}, shouldParameterize = true) => {
    const patterns = Array.isArray(pattern) ? pattern : [pattern];
    const lastValidPattern = [...patterns]
      .reverse()
      .find(pattern => canGenerateHrefFromSinglePattern(pattern, params, shouldParameterize));

    return generateHrefFromSinglePattern(
      lastValidPattern || patterns[0] || '',
      params,
      shouldParameterize
    );
  };
